import { Text } from '@rsos/base-components';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';
import styles from './NorfolkSouthernStatus.module.css';
import { EMPTY_VALUE } from './norfolkSouthernStatusUtils';

interface RelatedCallBoxProps {
  callerId?: string | null;
}

/** The call the consist request was raised for, if any. */
function RelatedCallBox({ callerId }: RelatedCallBoxProps): JSX.Element {
  return (
    <div className={styles.infoBox} data-name="norfolk-southern-related-call">
      <Text size="small" color="primaryText" fontWeight="bold">
        Related Call
      </Text>
      <Text size="normal" color="primaryText">
        {callerId ? formatInternationalPhoneNumberHuman(callerId) : EMPTY_VALUE}
      </Text>
    </div>
  );
}

export default RelatedCallBox;
